import React from 'react';
import './MapLegend.scss';
import stores from 'cd-eft/models/Stores';
import Draggable from 'react-draggable';

const setStore = stores.AppStore.surveyEngineeringStore;

const MapLegend = () => {
  return (
    (setStore.surveySummaryTable.length !== 0 || setStore.pointsOnMap) && (
      <Draggable
        axis="both"
        handle=".handle"
        defaultPosition={{ x: 0, y: 0 }}
        bounds=".design-workspace"
        grid={[1, 1]}
        scale={1}
      >
        <div className={`legend-container handle`} role="region" aria-label="Map Legend" tabIndex={0}>
          <div className="legend-head">Survey Points</div>

          {setStore.pointsOnMap ? (
            <>
              <div>
                <div className="map-point circle-point gis-blue">
                  <span className="usa-sr-only">circle shape</span>
                </div>
                <div>Existing Survey Point</div>
              </div>
              <div>
                <div className="map-point triangle-point text-green">
                  <span className="usa-sr-only">triangle shape</span>
                </div>
                <div>Unsaved Survey Point</div>
              </div>
            </>
          ) : (
            <>
              <div>
                <div className="map-point cross-point text-green">
                  <span className="usa-sr-only">green cross shape</span>
                </div>
                <div>Tinable Point</div>
              </div>
              <div>
                <div className="map-point cross-point text-red">
                  <span className="usa-sr-only">red cross shape</span>
                </div>
                <div>Not Tinable Point</div>
              </div>
              <div>
                <div className="map-point circle-point text-black">
                  <span className="usa-sr-only">black circle shape</span>
                </div>
                <div>Inactive Point</div>
              </div>
              {/* <div>
                <div className="map-point circle-point text-black">
                  <span className="usa-sr-only">black circle shape</span>
                </div>
                <div>Not Visible Point</div>
              </div> */}
            </>
          )}
        </div>
      </Draggable>
    )
  );
};

export default MapLegend;
